const courseConfig = {
  courseId: process.env.REACT_APP_COURSE_ID || 'aicourse',
  courseName: process.env.REACT_APP_COURSE_NAME || 'AI Mastery Course',
  tagline: process.env.REACT_APP_TAGLINE || 'Master Artificial Intelligence from Zero to Pro',
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  accentColor: process.env.REACT_APP_ACCENT_COLOR || '#6366f1',
};

export default courseConfig;
